import React, { Component } from 'react';
import { Link } from 'react-router-dom';


class NextUp extends Component {
  render(){
    // Destructuring :)
    const { previous='Previous page name', next='Next page name' } = this.props;
    const { previousURL = "/" , nextURL = "/" } = this.props;

    return(
      <div className="container">
        <div className="col col-1-2">
          <Link to={previousURL} alt="See more: \{previous\}" ><h2 className="slogan link link-static">← {previous}</h2> </Link>
        </div>
        <div className="col col-1-2 align-right">
          <Link to={nextURL} alt="See more: \{next\}" > <h2 className="slogan link link-static">{next} →</h2> </Link>
        </div>
      </div>
    );
  }
}

export default NextUp;



// WEBPACK FOOTER //
// ./src/layout/warp/NextUp.js